import "./PipelineCard.scss";

export function PipelineCard({ count, label, className, Icon, onClick }) {
  return (
    <div
      className={`pipeline-card${className ? ` ${className}` : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="pipeline-card__text">
        <span className="pipeline-card__count">{count}</span>
        <span className="pipeline-card__label">{label}</span>
      </div>
      {Icon && (
        <span className="pipeline-card__icon">
          <Icon />
        </span>
      )}
    </div>
  );
}

export function PipelineCardGroup({ children }) {
  return <div className="pipeline-card-group">{children}</div>;
}
